import { UserProfile } from '@/typings/api/User'
import VueRouter, { Route } from 'vue-router'
import { Menu } from '@/typings/common'

import * as MENU_FOLDERS from '@/helpers/enums/menu-folders'
import { accessAdmin, accessBase } from '@/plugins/access'
import { ERRORS_ROUTES } from '@/views/Errors/utils'


export const createGetMenuItem = (router: VueRouter, profile: UserProfile | null) => (
  function getMenuItem(menu: Menu): Menu {
    let resolved: Route
    let route: Route

    try {
      const result = router.resolve(menu.route)
      resolved = result.resolved
      route = result.route
    } catch {
      return { ...menu }
    }

    if ((!route || route.name === ERRORS_ROUTES.ERROR_404) && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      // console.warn(`[App warn]: for menu "${_.id}" don't fined route`)
    }

    const folder = Object.values(MENU_FOLDERS).find((_) => (
      resolved.matched[0]?.path.includes(_.name)
    ))

    let disabled = false
    if (!route || !route.meta) {
      //
    } else if ('permission' in route.meta) {
      const { permission } = route.meta as { permission: string }
      const { access } = router.app.$options as unknown as { access: typeof accessBase }
      disabled = !access(profile, permission) && !accessAdmin(profile, permission)

      if (disabled) return menu

      if (menu.children) {
        return {
          ...menu,
          disabled,
          folder: folder?.name,
          children: menu.children.map(getMenuItem),
        }
      }

      return { ...menu, disabled, folder: folder?.name }
    }

    return { ...menu, folder: folder?.name }
  })
